import styled from 'styled-components';

import { Button, Input } from 'reactstrap';

export const Label = styled.label`
font-size: 18px;
  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 800px;
  min-height: 50vh;
  background-color: #f8f9fa;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.42);
  z-index: 1551;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  /* Centralizando todo o conteúdo */

  @media (max-width: 768px) {
    width: 90%;
    max-width: 90%;
    padding: 15px;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 10px;
  }
`;


export const StyledInfo = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap; /* <- permite o texto quebrar corretamente */
  gap: 4px; /* espaço entre ícone e texto */
  color: #1565c0;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin: 10px auto;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-radius: 6px;
  max-width: 90%; /* evita que estoure em telas pequenas */
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 6px 10px;
  }
`;


export const StyledH2 = styled.h2`
  font-weight: 700;
  color: #0C2B6E;
  font-size: 28px;
  text-align: center;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const StyledH3 = styled.h3`
  font-weight: 650;
  color: #0c2b6eec;
    font-size: 22px;
  text-align: center;
  padding-bottom: 10px;
    @media (max-width: 480px) {
    font-size: 22px;
  }
`;
export const BackChoice = styled.span`
  display: flex;
  align-items: center; /* Garante que o ícone e o texto fiquem alinhados verticalmente */
  justify-content: center;
  cursor: pointer;
  color: #0C2B6E;
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 17px;
  gap: 3px; /* Adiciona um espaço consistente entre o texto e o ícone */
  
  margin-top: 10px; /* Removido para garantir que os links fiquem alinhados */
  
  span {
    display: flex;
    align-items: center; /* Alinha o ícone com o texto */
  }

  @media (max-width: 1330px) {
    font-size: 15px;
    gap: 2px; /* Ajuste o gap para dar um pouco de espaçamento entre o texto e o ícone */
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50%;  /* Ajuste a largura conforme necessário */

  gap: 10px;

  @media (max-width: 768px) {
    width: 70%; /* Apenas uma redução de tamanho em telas menores */
  }

  @media (max-width: 480px) {
    width: 100%;  /* Reduz um pouco mais em telas muito pequenas */
    gap: 2px;
  }
`;

export const InputAuth = styled(Input)`
  width: 48%;  /* Ajuste o tamanho para que fiquem em 2 duplas */
  height: 55px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #999;
  border-radius: 8px;
  margin: 0 1; /* Remover margem extra entre as caixinhas */

  &:focus {
    outline: none;
    border-color: #007bff; /* Cor de foco */
  }

  &::placeholder {
    color: #999;
  }

  /* Adicionando margem maior entre a segunda e a terceira dupla */
  &:nth-child(3) {
    margin-left: 10px;
  }

  /* Adicionando margem maior entre a quarta e a quinta dupla */
  &:nth-child(5) {
    margin-left: 10px;
  }

  @media (max-width: 768px) {

  }

  @media (max-width: 480px) {
padding: 0px;
  }
`;



export const ButtonGroup = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  width: 100%;  /* Garantir que ocupe toda a largura disponível */

  @media (max-width: 768px) {
    flex-direction: column;  /* Coloca os botões em uma coluna */
  }
`;

export const SendText = styled.h4`
  font-size: 21px;
  margin-bottom: 10px;
  font-weight: 670;
  text-align: center;
  padding: 5px;

  @media (max-width: 768px) {
    font-size: 18px;  /* Fonte um pouco menor em telas de até 768px */
  }

  @media (max-width: 480px) {
    font-size: 16px;  /* Fonte ainda menor em telas muito pequenas */
  }
`;


export const ButtonNext = styled(Button)`
  width: 85%;
  padding: 10px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(268.2deg, #006EB0 -5.28%, #00AFEF 100%, #007DC3 100%);
  border: none;
  font-weight: 650;

  @media (max-width: 768px) {
    width: 100%;  /* Botão ocupa 100% da largura na tela menor */
  }
`;

export const ButtonSend = styled(Button)`
  width: 40%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(268.2deg, #006EB0 -5.28%, #00AFEF 100%, #007DC3 100%);
  border: none;
  font-weight: 650;

  @media (max-width: 768px) {
    width: 50%;  /* Aumenta o tamanho para 70% da largura disponível */
  }

  @media (max-width: 480px) {
    width: 60%;  /* Em dispositivos móveis, o botão ocupa 100% */
  }
`;
